import DataTableTitle from "../../DataTableComponents/DataTableTitle";

const ShiftBulananColumns = (dateList) => {
  const isWeekend = (date) => {
    const day = date.getDay();
    return day === 0 || day === 6;
  };

  return [
    {
      name: <DataTableTitle text={"Nama Staf"} />,
      selector: (row) => row.nama,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Lokasi"} />,
      selector: (row) => row.shifts?.lokasi || "-",
      sortable: true,
      wrap: true,
    },
    ...dateList.map((date) => {
      const today = new Date(date.tanggal);
      return {
        name: <DataTableTitle text={today.getDate()} />,
        selector: (row) => {
          const shift = row.shifts?.daily_shifts?.find(
            shift => new Date(shift.date).getDate() === today.getDate()
          );
          return <div>{shift?.shift_display || shift?.shift || "-"}</div>;
        },
        wrap: true,
        conditionalCellStyles: [
          {
            when: () => isWeekend(today),
            style: {
              backgroundColor: '#FFE6E6',
            },
          },
        ],
      };
    }),
  ];
};

export default ShiftBulananColumns;